<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row justify="center">
        <v-dialog :eager="true" v-model="sendMessageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <SendMessage ref="sendMessageDialog" @close="closeSendMesage" style="height:100%">
            </SendMessage>
        </v-dialog>
        <v-container fluid>
            <v-form ref="searchIncidentsForm" @submit="searchIncidents" onSubmit="return false">
                <v-card flat>
                    <v-container fluid>
                        <v-layout>
                            <v-flex md3>
                                <v-select :items="premises"
                                          label="Filter By Premise"
                                          item-text="name"
                                          v-model="filter.premiseId"
                                          item-value="id"></v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-btn outlined color="success" @click="searchIncidents()">
                            Search
                            <v-icon right dark>mdi-magnify-plus-outline</v-icon>
                        </v-btn>
                        <v-btn outlined color="warning" @click="resetFilter()">
                            Reset
                            <v-icon right dark>mdi-autorenew</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
            <v-data-table :headers="headers"
                          :items="incidents"
                          class="elevation-1"
                          :options.sync="pagination"
                          :loading="loading"
                          :server-items-length="totalRecords">
                <template v-slot:item.dateTime="{item}">
                    <date-time-display v-bind:date="item.dateTime"></date-time-display>
                </template>
                <template v-slot:item.statusDate="{item}">
                    <date-time-display v-bind:date="item.statusDate"></date-time-display>
                </template>
                <template v-slot:item.latitude="{item}">
                    <a :href="'https://maps.google.com/?q='+item.latitude+','+item.longitude" target="_blank">{{item.latitude}} / {{item.longitude}}</a>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn icon v-if="$permissionHolder.hasPermission('FIRST_ALERT.COMMUNICATIONS') && item.statusCode != 'CLOSED'" v-on:click="openIncidentCommunications(item.id)">
                        <v-icon dark>mdi-chat</v-icon>
                    </v-btn>
				    <v-btn icon v-if="$permissionHolder.hasPermission('FIRST_ALERT.COMMUNICATIONS') && item.statusCode == 'CLOSED'"  v-on:click="viewIncidentCommunications(item.id)">
					     <v-icon dark>mdi-history</v-icon>
				    </v-btn>
                    <v-btn icon v-if="$permissionHolder.hasPermission('FIRST_ALERT.ANNOUNCE') && item.statusCode != 'CLOSED' " v-on:click="openSendMessage(item.premiseId)">
                        <v-icon dark>mdi-bullhorn</v-icon>
                    </v-btn>
                    <close-incident v-if="item.statusCode != 'CLOSED'" :incident-id="item.id" :is-cad-incident="!item.cadEventType || item.cadEventType == ''" @onClose="afterCloseIncident" icon>
                        <v-icon dark>mdi-close</v-icon>
                    </close-incident>
                </template>

            </v-data-table>
        </v-container>
    </v-row>
</template>

<script>
    import api from '@/api';
    import DateTimeDisplay from "@/components/common/DateTimeDisplay";
    import SendMessage from "@/components/premise/SendMessage";
    import CloseIncident from "@/components/CloseIncident";
    export default {
        name:'OrganizationIncidents',
        components: {SendMessage, DateTimeDisplay,CloseIncident},
        watch: {
            pagination: {
                handler () {
                    this.searchIncidents()
                },
                deep: true
            }
        },
        data() {
            return {
                headers : [
                    {text:'Premise',value:'premiseName'},
                    {text:'User',value:'userName',sortable:false},
                    {text:'Date / Time',value:'dateTime'},
                    {text:'Tracking #',value:'trackingNumber'},
                    {text:'Event',value:'eventText'},
                    {text:'CAD Event',value:'cadEventType'},
                    {text:'Lat / Lng',value:'latitude'},
                    {text:'Status',value:'statusDesc'},
                    {text:'Status Date',value:'statusDate'},
                    {text:'Actions',value:'actions'}
                ],
                loading:false,
                incidents : [],
                organizationId : null,
                premises : [],
                totalRecords : null,
                pagination: {
                    sortBy : ['dateTime'],
                    sortDesc : ['DESC']
                },
                sendMessageDialog : false,
                filter : {
                    premiseId : null
                }
            };
        },
        mounted() {
            this.organizationId = this.$route.params.organizationId;
            api.premise.search({
                organizationId : this.organizationId
            }).then(r => this.premises = r.list);
        },
        methods: {
            afterCloseIncident() {
                this.searchIncidents();
            },
            openSendMessage(premiseId) {
                this.sendMessageDialog = true;
                this.$refs.sendMessageDialog.open(premiseId);
            },
            openIncidentCommunications(cadRequestId) {
                this.$router.push({'path': `/incident/${cadRequestId}`});
            },
		  viewIncidentCommunications(cadRequestId) {
			   this.$router.push({'path': `/incident-view/${cadRequestId}`});
		  },
            closeSendMesage() {
                this.sendMessageDialog = false;
            },
            searchIncidents : function() {
                this.loading = true;
                const that = this;
                const sortDesc = !!this.pagination.sortDesc[0];
                const sortOrder = sortDesc ? 'DESC' : 'ASC';
                api.incident.search({
                    pageNumber: this.pagination.page - 1,
                    rowsPerPage: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy,
                    sortOrder: sortOrder,
                    organizationId : this.organizationId,
                    premiseId : this.filter.premiseId
                }).then(function(data) {
                    that.incidents = data.list;
                    that.totalRecords = data.totalRecords;
                    that.loading = false;
                });
            },
            resetFilter: function () {
                this.filter = {};
                this.searchIncidents();
            }
        }
    }

</script>

<style>
    .v-form .container {
        padding:16px;
    }
</style>